import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETarget} from '../../../react-oe/oe-target';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OEBBraunTargetType = {
    op:             'op',
    anatomy:        'anatomy'
};

OEBBraunTargetType.all = [
    OEBBraunTargetType.anatomy,
    OEBBraunTargetType.op
];

export const opTargets = [
    OETarget.surgeryBbraunOneKnee,
];

export const OEBBraunStartSelectionContent = {

    // alpha
    [OEBBraunTargetType.op]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryBbraunOneKnee,
                    ]
                }
            ]
        }
    ],

    [OEBBraunTargetType.anatomy]: [
        {
            subcategories: [
                {
                    items: [
                        {target: OETarget.humanThighKnee, label: {text: 'Thigh and knee', id: 'target_menu_humanThighKnee'}},
                    ]
                },
            ]
        }
    ],

    // beta
    [OEBBraunTargetType.op + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryBbraunOneKnee,
                    ]
                }
            ]
        }
    ],
    
    [OEBBraunTargetType.anatomy + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        {target: OETarget.humanThighKnee, label: {text: 'Thigh and knee', id: 'target_menu_humanThighKnee'}},
                    ]
                },
            ]
        }
    ],

    // prod
    [OEBBraunTargetType.op + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryBbraunOneKnee,
                    ]
                }
            ]
        }
    ],
    
    [OEBBraunTargetType.anatomy + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        {target: OETarget.humanThighKnee, label: {text: 'Thigh and knee', id: 'target_menu_humanThighKnee'}},
                    ]
                },
            ]
        }
    ],
};

OEBBraunStartSelectionContent.modules = [
    {id: OEBBraunTargetType.op, icon: OEIconCodes.bbraun.opTarget, categories: OEBBraunStartSelectionContent.op},
    {id: OEBBraunTargetType.anatomy, icon: OEIconCodes.bbraun.anatomyTarget, categories: OEBBraunStartSelectionContent.anatomy}
];

OEBBraunStartSelectionContent.modulesBeta = [
    {id: OEBBraunTargetType.op, icon: OEIconCodes.bbraun.opTarget, categories: OEBBraunStartSelectionContent.op + OEAlphaBetaProdTypes.beta},
    {id: OEBBraunTargetType.anatomy, icon: OEIconCodes.bbraun.anatomyTarget, categories: OEBBraunStartSelectionContent.anatomy + OEAlphaBetaProdTypes.beta}
];

OEBBraunStartSelectionContent.modulesProduction = [
    {id: OEBBraunTargetType.op, icon: OEIconCodes.bbraun.opTarget, categories: OEBBraunStartSelectionContent.op + OEAlphaBetaProdTypes.prod},
    {id: OEBBraunTargetType.anatomy, icon: OEIconCodes.bbraun.anatomyTarget, categories: OEBBraunStartSelectionContent.anatomy + OEAlphaBetaProdTypes.prod}
];